import { memo } from 'react';

import URL from '@/common/app/utils/urlsUtils';
import { BlogCard } from '@/entities/Blogs/ui/BlogCard';
import { TPublicBlogs } from '@/entities/Blogs/domain/Blogs.domain';
import { CardsContainer } from '@/screens/HomePage/ui/CardsContainer';

import * as S from './VisitorsGuide.styles';
import { BottomButton } from '@/common/ui/buttons/BottomButton/BottomButton';
import { useViewMoreBlogs } from '@/common/app/hooks/useViewMoreBlogs';
import { Preloader } from '@/common/ui/loaders/Preloader';
import { Button } from '@/common/ui';

export type VisitorsGuideBlogsProps = {
    linkToBlogs?: string;
    blogs: TPublicBlogs;
    isMobileView: boolean;
    title: string;
    btnTitle?: string;
    subtitle?: string;
    destinationId: string;
    outline?: boolean;
};

const DEFAULT_MOBILE_COUNT = 2;
const DEFAULT_DESKTOP_COUNT = 6;

const VisitorsGuideBlogsContainer = ({
    blogs,
    isMobileView,
    destinationId,
    title,
    btnTitle,
    subtitle,
    outline,
}: VisitorsGuideBlogsProps) => {
    const { blogsList, isBlogsLoading, isBlogsTouched, isBlogsEnded, viewMoreBlogs } =
        useViewMoreBlogs(destinationId, blogs);

    if (!blogs.items.length) {
        return <></>;
    }

    const listToView = isBlogsTouched
        ? blogsList
        : blogsList.slice(0, isMobileView ? DEFAULT_MOBILE_COUNT : DEFAULT_DESKTOP_COUNT);

    return (
        <S.CardsWrapper>
            <CardsContainer title={title} description={subtitle} noHeightLimit>
                {listToView.length > 0 &&
                    listToView.map((blog) => {
                        return (
                            <BlogCard
                                cardLink={`/blog/${blog.slug}/`}
                                imageSrc={`${URL.image}/blog/${blog.image.id}/1000x460/${blog.image.slug}.jpg`}
                                date={blog.updated_at}
                                title={blog.title}
                                location={blog.category.name}
                                key={blog.slug}
                            />
                        );
                    })}
            </CardsContainer>
            {!isBlogsEnded &&
                !isBlogsLoading &&
                (outline ? (
                    <S.BtnWrapperOutline>
                        <Button variant="transparent" onClick={viewMoreBlogs}>
                            {btnTitle || 'View More'}
                        </Button>
                    </S.BtnWrapperOutline>
                ) : (
                    <S.BtnWrapper>
                        <BottomButton title={btnTitle || 'View More'} onClick={viewMoreBlogs} />
                    </S.BtnWrapper>
                ))}
            {isBlogsLoading && <Preloader />}
        </S.CardsWrapper>
    );
};

export const VisitorsGuideBlogs = memo(VisitorsGuideBlogsContainer);
